/**
 * Setup the global elements of the react app:
 *  - redux store
 *  - react router
 *  - main component: App
 */
import { createCartoSlice } from '@carto/react-redux';
import { setDefaultCredentials } from '@deck.gl/carto';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { initialState } from 'store/initialStateSlice';
import App from './App';
import configureAppStore from './store/store';

import firebaseConfig from 'config/firebaseConfig';
import firebase from 'firebase/compat/app';

const store = configureAppStore();
store.reducerManager.add('carto', createCartoSlice(initialState));

setDefaultCredentials({ ...initialState.credentials });
firebase.initializeApp(firebaseConfig);
firebase.auth().onAuthStateChanged((user) => {
  if (user) {
    user.getIdToken(true);
  }
});
// const auth = getAuth()
// connectAuthEmulator(auth, "http://127.0.0.1:9099")

firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION); // Logs out when the close the tab/window
ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>,
  document.getElementById('root')
);
